import { useTranslation } from "react-i18next";
import { Box, Divider, Skeleton, Typography } from "@mui/material";

const JobOverview = ({
  jobTitle,
  overviewList,
  isOverviewLoading,
}: {
  jobTitle?: string;
  overviewList: { icon: React.ReactNode; title: string }[];
  isOverviewLoading: boolean;
}) => {
  const { t } = useTranslation("goHire", { keyPrefix: "createJobPage.previewAndPublishJob" });

  if (isOverviewLoading) {
    return (
      <Box component="section" sx={styles.jobInfoContainer}>
        <Skeleton variant="text" sx={{ width: "50%" }} />
        <Divider flexItem orientation="horizontal" />
        <Box sx={styles.jobInfoListContainer}>
          {Array.from({ length: 5 }).map((_, index) => (
            <Box sx={styles.jobInfoListItem}>
              <Skeleton variant="rounded" sx={{ width: "24px", height: "24px" }} />
              <Skeleton variant="text" sx={{ width: "250px", height: "24px" }} />
            </Box>
          ))}
        </Box>
      </Box>
    );
  }

  return (
    <Box component="section" sx={styles.jobInfoContainer}>
      <Typography sx={styles.jobInfoTitle} title={jobTitle}>
        {jobTitle ?? "--"}
      </Typography>
      <Divider flexItem orientation="horizontal" />
      <Box sx={styles.jobInfoListContainer}>
        {overviewList.map(({ icon, title }) => (
          <Box sx={styles.jobInfoListItem}>
            {icon}
            <Typography sx={styles.jobInfoListItemTitle}>{title}</Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default JobOverview;

const styles = {
  jobInfoContainer: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: "24px",
  },
  jobInfoListContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },
  jobInfoListItem: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  jobInfoTitle: {
    fontFamily: "Montserrat",
    color: "var(--Dark---1000, #111)",
    fontSize: "18px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "28px",
    maxWidth: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  jobInfoListItemTitle: {
    fontFamily: "Montserrat",
    color: "var(--Dark-Mode---100, #1E2021)",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "24px",
  },
};
